<template dark>
  <div v-resize="Resize" id="app">
    <offline @detected-condition="handleConnectivityChange"></offline>
    <template v-if="this.$store.state.authenticated && !$route.meta.public">
      <v-app>
        <!-- <actionCenter></actionCenter> -->
        <appDrawer class="app--drawer" :style="this.$store.state.appDrawerStyle"></appDrawer>
        <div style="position: fixed; width: 100%; z-index: 11;">
          <toolbar class="app--toolbar" style="position: relative !important; z-index: 11; box-shadow:none !important;">
          </toolbar>
          <secondaryToolbar class="secondaryToolbar" style="position: relative !important;"></secondaryToolbar>
        </div>
        <v-main :style="this.$store.state.globalStyle">
          <div>
            <div v-if="this.getRouteForTracking == false">
              <PageHeader></PageHeader>
            </div>
            <router-view @authenticated="setAuthenticated" />
            <v-footer v-if="$route.path == '/tracking'" ref="footer" absolute
              style="bottom: 0% !important;position: absolute; opacity: 0.6;background-color: #f5f5f500 !important;">
              <v-col class="text-right footerText" cols="12" style="padding-bottom: 0;">
                &copy; {{ new Date().getFullYear() }} Boson TI SA de CV.
                {{ $t("rights") }} &nbsp;
              </v-col>
            </v-footer>
            <v-footer v-else ref="footer" absolute style="bottom: 0% !important;">
              <v-col class="text-center" style="padding-top:0;padding-bottom: 4px;">
                <v-btn v-for="icon in icons" :key="icon" class="mx-4" :color="colorTheme" icon
                  v-on:click="redirectToWebSiteBoson(icon)">
                  <v-icon class="icon-size">{{ icon }}</v-icon>
                </v-btn>
              </v-col>
              <v-col class="text-center footerText" cols="12" style="padding-top:0;padding-bottom: 0;">
                &copy; {{ new Date().getFullYear() }} Boson TI SA de CV.
                {{ $t("rights") }} &nbsp;
              </v-col>
            </v-footer>
            <div v-if="visible">
              <settings></settings>
            </div>
            <v-bottom-sheet v-model="bottomSheet" v-if="this.$store.state.windowSize.width > 1263">
              <v-card>
                <v-toolbar color="#424242" dark>
                  <v-icon class="icon-size-subtitle mr-3">mdi-car-cog</v-icon>
                  <v-toolbar-title class="subtitle1Text" color="white">
                    {{
                      $t("filterVehicles")
                    }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-divider class="mx-3" inset vertical
                    v-if="$route.path != '/individualFuel' && $route.path != '/tracking' && $route.path != '/home'"></v-divider>
                  <v-toolbar-items
                    v-if="$route.path != '/individualFuel' && $route.path != '/tracking' && $route.path != '/home'">
                    <v-row align="center">
                      <v-col cols="12" sm="2" style="padding-right: 0;">
                        <v-checkbox class="mx-2" v-model="checkFastList" hide-details :disabled="
                          this.$store.state.vehiclesAggregates.length == 0
                        " :color="colorTheme"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="10" style="padding-left: 0;">
                        <v-btn class="regularText" dark text :disabled="
                          this.$store.state.vehiclesAggregates.length == 0
                        " @click="changeTable(true)">
                          {{ $t("quickList").toUpperCase() }}:{{
                            this.$store.state.vehiclesAggregates.length
                          }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar-items>
                  <v-divider class="mx-3" inset vertical></v-divider>
                  <v-toolbar-items>
                    <v-btn class="regularText" dark text :disabled="disableFV" @click="setAccount()">{{ $t("save") }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <filterVehicles></filterVehicles>
              </v-card>
            </v-bottom-sheet>
            <v-dialog v-model="bottomSheet" fullscreen hide-overlay transition="dialog-bottom-transition"
              v-if="this.$store.state.windowSize.width <= 1263">
              <v-card>
                <v-toolbar color="#424242" dark>
                  <v-btn dark icon v-on:click="closeDialog()">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                  <v-icon large style="margin-right: 15px;">mdi-car-cog</v-icon>
                  <v-toolbar-title color="white">
                    {{
                      $t("filterVehicles")
                    }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text :disabled="disableFV" v-on:click="setAccount()">{{ $t("save") }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-container
                  v-if="$route.path != '/individualFuel' && $route.path != '/tracking' && $route.path != '/home'">
                  <v-row>
                    <v-checkbox v-model="checkFastList" hide-details :disabled="
                      this.$store.state.vehiclesAggregates.length == 0
                    " :color="colorTheme" style="padding-top: 0px; padding-left: 20px;"></v-checkbox>
                    <v-btn text :disabled="
                      this.$store.state.vehiclesAggregates.length == 0
                    " v-on:click="changeTable(true)" style="padding-top: 20px;">
                      {{ $t("quickList").toUpperCase() }}:{{
                        this.$store.state.vehiclesAggregates.length
                      }}
                    </v-btn>
                  </v-row>
                </v-container>
                <filterVehicles></filterVehicles>
              </v-card>
            </v-dialog>
            <v-dialog v-model="initialSettings" persistent transition="dialog-bottom-transition" max-width="55%"
              v-if="this.$store.state.windowSize.width >= 1263">
              <initialSettings></initialSettings>
            </v-dialog>
            <v-dialog v-model="initialSettings" fullscreen hide-overlay transition="dialog-bottom-transition"
              v-if="this.$store.state.windowSize.width <= 1263">
              <initialSettings></initialSettings>
            </v-dialog>
            <v-dialog v-model="calendarTime" fullscreen hide-overlay transition="dialog-bottom-transition"
              v-if="visible == false">
              <calendarTime></calendarTime>
            </v-dialog>
          </div>
        </v-main>
      </v-app>
    </template>
    <template v-else-if="$route.meta.public">
      <router-view @authenticated="setAuthenticated" />
    </template>
    <v-dialog v-model="sessionexp" persistent width="300">
      <v-card color="grey darken-1" dark>
        <v-card-text>{{ $t("session") }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text v-on:click="SessionExpired()">
            {{
              $t("accept").toUpperCase()
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settings" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#424242" dark>
          <v-btn icon v-on:click="closeSettings()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title color="white">{{ settingsTitle }}</v-toolbar-title>
        </v-toolbar>
        <personalization></personalization>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" content-class="regularText" :multi-line="mode === 'multi-line'" :right="x === 'right'" :timeout="timeout"
      :top="true" :vertical="mode === 'vertical'">
      {{ text }}
      <template v-slot:action="{ attrs }">
      <v-btn class="icon-size" :color="colorTheme" text @click="snackbar = false" v-bind="attrs">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
    </v-snackbar>
  </div>
</template>

<script>
//failed update token
import axios from "axios";
import moment from "moment";
import offline from "v-offline";
import { mapState } from "vuex";
//var Stomp = require('stompjs');

export default {
  name: "App",
  components: {
    offline,
    toolbar: () => import("@/components/toolbar"),
    secondaryToolbar: () => import("@/components/secondaryToolbar"),
    appDrawer: () => import("@/components/appDrawer"),
    PageHeader: () => import("@/components/PageHeader"),
    filterVehicles: () => import("@/components/filterVehicles"),
    settings: () => import("@/components/settings"),
    personalization: () => import("@/components/personalization"),
    initialSettings: () => import("@/components/initialSettings"),
    calendarTime: () => import("@/components/calendarTime"),
    actionCenter: () => import("@/components/actionCenter")
  },
  data() {
    return {
      colorSelect: "",
      icons: ["mdi-earth", "mdi-facebook", "mdi-linkedin"]
    };
  },
  created() {
    this.$store.dispatch("getAllItemsDB");
    this.$store.commit("setValuesLanguage");
    this.$store.commit("setChartsValue");
  },

  updated: function () {
    var vm = this;
    this.$nextTick(function () {
      var auth = JSON.parse(localStorage.getItem("auth")) || false;
      var route =
        localStorage.getItem("route") == "undefined" ||
          localStorage.getItem("route") == "null"
          ? "home"
          : localStorage.getItem("route");
      if (vm.$route.path === "/") {
        if (auth == true) {
          vm.$router.replace({ name: route });
        } else {
          vm.$store.commit("auth", false);
          vm.$router.replace({ name: "login" });
        }
      } else {
        if (auth == true && vm.$route.path == "/login") {
          // var userData = JSON.parse(localStorage.getItem("UserDataAccessList"));
          // var selectedAccess = userData.ServiceList;
          // var AT_auth = selectedAccess.AlertTruck;
          // var AF_auth = selectedAccess.AlertFuel_Individual;
          // var TR_auth = selectedAccess.Tracking;
          // if (AT_auth) {
          //   vm.$router.replace({ name: "dashboard" });
          // } else if (TR_auth && AF_auth) {
          //   vm.$router.replace({ name: "tracking" });
          // } else if (TR_auth) {
          //   vm.$router.replace({ name: "tracking" });
          // } else if (AF_auth) {
          //   vm.$router.replace({ name: "individualFuel" });
          // }
          vm.$router.replace({ name: "home" });
        } else if (auth == false) {
          vm.$store.commit("auth", false);
          vm.$router.replace({ name: "login" });
        } else {
          var initialSettings = JSON.parse(
            localStorage.getItem("initialSettings")
          );
          if (initialSettings) {
            vm.$store.commit("initialSettings", initialSettings);
          }
        }
      }
      localStorage.setItem("route", vm.$route.name);
    });
  },
  computed: {
    ...mapState([
      "sessionexp",
      "text",
      "mode",
      "timeout",
      "x",
      "y",
      "colorTheme",
      "settings",
      "initialSettings",
      "settingsTitle",
      "disableFV",
      "calendarTime",
      "visible"
    ]),
    snackbar: {
      get: function () {
        return this.$store.state.snackbar;
      },
      set: function (value) {
        this.$store.commit("snackbar", false, "");
      }
    },
    bottomSheet: {
      get: function () {
        return this.$store.state.bottomSheet;
      },
      set: function (value) {
        this.$store.commit("bottomSheet");
      }
    },
    checkFastList: {
      get: function () {
        return this.$store.state.checkFastList;
      },
      set: function (value) {
        this.$store.commit("checkFastList", value);
      }
    },
    getRouteForTracking() {
      var path = this.$route.name;
      if (path == "tracking") {
        return true;
      }
      return false;
    }
  },
  mounted() {
    var errorMaps = false;
    var vm = this;
    window.gm_authFailure = function () {
      errorMaps = true;
      vm.$store.commit("googleErrors", errorMaps);
    };
    this.Resize();
    this.changeColorTheme();
    this.switchDarkMode();
    // //el puerto se debe a rabbit pero se puede cambiar
    // this.$store.state.client = Stomp.client('ws://' + window.location.hostname + ':15674/ws');
    // console.log(this.$store.state.client);
    // var vm = this;
    // var on_connect = function (x) {
    //   //al suscribirme estara escuchando los mensajes que lleguen
    //   var id = vm.$store.state.client.subscribe("/topic/test", function (message) {
    //     console.log(message);
    //     vm.$store.state.received.push(message.body);
    //     var messageParsed = JSON.parse(message.body);
    //     vm.$store.state.notiArray.push(messageParsed);
    //     vm.$store.state.notiNumber = ++vm.$store.state.notiNumber;
    //   });
    //   vm.$store.state.client.debug = function (str) {
    //     vm.$store.state.logs.push(str);
    //   };
    // };
    // var on_error = function () {
    //   console.log('error');
    // };
    // //se hace la conexion
    // this.$store.state.client.connect('guest', 'guest', on_connect, on_error, '/');
    ////NOTA: para utilizar el código comentado, instalar el package "stompjs", se utilizó con la versión "^2.3.3",
  },
  methods: {
    redirectToWebSiteBoson(linkTo) {
      if (linkTo == "mdi-earth") {
        window.open("https://www.bosonti.com/", "_blank");
      } else if (linkTo == "mdi-facebook") {
        window.open("https://www.facebook.com/bosonti", "_blank");
      } else if (linkTo == "mdi-linkedin") {
        window.open("https://www.linkedin.com/company/bosonti/", "_blank");
      }
    },
    switchDarkMode() {
      var switchDarkMode = localStorage.getItem("darkMode");
      var color = switchDarkMode == "true" ? "" : "#f5f5f5";
      this.$store.commit("setColor", color);
      if (switchDarkMode == "true") {
        this.$store.commit("swicth");
        this.$vuetify.theme.dark = switchDarkMode;
        this.$store.commit("progressColor", switchDarkMode);

        var ItemsDashboard = JSON.parse(localStorage.getItem("ItemsDashboard"));
        this.$store.dispatch("customCharts", ItemsDashboard);
      }
    },
    changeColorTheme() {
      var changeColor = localStorage.getItem("colorSelected");
      if (changeColor != undefined) {
        this.$store.commit("setColorSelected", changeColor);
        this.$vuetify.theme.themes.light.primary = changeColor;
        this.$vuetify.theme.themes.dark.primary = changeColor;
      }
    },
    setAuthenticated(status) {
      this.$store.commit("auth", status);
    },
    Resize() {
      this.$store.commit("onResize");
    },
    setAccount() {
      this.$store.dispatch("setPersonalization", ["AccountFilters"]);
      this.$store.commit("setAccount", true);
      localStorage.setItem("vehicles", this.$store.state.vehicles.length);
      localStorage.setItem(
        "quickList",
        JSON.stringify(this.$store.state.vehiclesAggregates)
      );
      localStorage.setItem("checkQuickList", this.$store.state.checkFastList);
      if (this.$route.path == "/dashboard") {
        this.$store.dispatch("getItemsDashboard", [true, false]);
      } else if (this.$route.path == "/vehiclesExceptions") {
        setTimeout(() => {
          this.$store.dispatch("fillExceptionCharts");
        }, 5000);
      } else if (this.$route.path == "/accountBalancePage") {
        setTimeout(() => {
          this.$store.dispatch("chartFillAcountBalance");
        }, 5000);
      } else if (this.$route.path == "/tracking") {
        setTimeout(() => {
          for (
            var i = 0;
            i < this.$store.state.listOfMarkersInTracking.length;
            i++
          ) {
            this.$store.state.listOfMarkersInTracking[i].setMap(null);
          }
          this.$store.state.listOfMarkersInTracking = [];
          var mC = this.$store.state.markerClusterTracking;
          mC.clearMarkers();
          // this.$store.commit("cleanClustersAndMarkersPolyline");
          this.$store.commit("trackingChange", true);
          // this.$store.dispatch("fleetLastPosition");
        }, 2000);
      } else if (this.$route.path.includes("/reportsPage")) {
        this.$store.dispatch("getListOfReports");
      } else if (this.$route.path == "/individualFuel") {
        var vehicle = this.$store.state.vehicleSelectedAF;
        if (vehicle != undefined && vehicle != null) {
          localStorage.setItem("vehicleAF", JSON.stringify(vehicle));
          this.$store.commit("viewSkeletonsFP", true);
          this.$store.commit("viewSkeletonsAR", true);
          this.$store.commit("viewSkeletonsRL", true);
          this.$store.dispatch("lastLevelWS", { vehicleId: vehicle.MovilId });
          this.$store.state.nickFromVehSelectedAF = vehicle.Nick;
          this.$store.state.movilIdFromVehSelectedAF = vehicle.MovilId;
          this.$store.dispatch("fuelPerformance", {
            vehicleId: vehicle.MovilId,
            showMore: false
          });
        }
      }
      this.$store.commit("selectionNames");
      if (this.$route.path == "/dashboard") {
        this.$store.dispatch("getCarrierInfo");
      }
    },
    handleConnectivityChange(status) {
      this.$store.dispatch("handleConnectivityChange", status);
    },
    SessionExpired() {
      this.$store.dispatch("destroyDB");
      this.$store.commit("auth", false);
      this.$store.commit("sessionexp", false);
    },
    closeDialog: function () {
      this.$store.commit("bottomSheet");
    },
    closeSettings: function () {
      this.$store.commit("settings");
    },
    changeTable: function (val) {
      this.$store.commit("changeTable", val);
    }
  }
};
</script>

<style>
@import "./assets/styles/main.less";
</style>